import consumer from ".././channels/consumer"

document.addEventListener('turbolinks:load', function() {
  const podcastEpisodeEl = document.getElementById('js-podcast-episode-transcript');

  window.subscribePodcastEpisodeChannel = function(podcastEpisodeId, podcastEpisodeStatus) {
    if (podcastEpisodeStatus !== 'completed') {
      consumer.subscriptions.create({ channel: "PodcastEpisodeChannel", podcast_episode_id: podcastEpisodeId }, {
        received(data) {
          if (data.transcript_status === 'completed') {
            const transcriptContainer = document.getElementById('vtt-container');
            transcriptContainer.classList.remove('podcast-no-transcript', 'pb-5');
            transcriptContainer.classList.add('podcast-transcript');
            transcriptContainer.dataset.transcript = data.transcript_url;
            transcriptContainer.dataset.transcriptType = data.transcript_type;
            transcriptContainer.dataset.language = data.language;
            transcriptContainer.dataset.audioSyncEnabled = data.audio_sync_enabled;

            // Optional: the episode may have become session-eligible while the
            // transcript was generating. Absent from the payload, nothing changes.
            if (data.sessions_enabled !== undefined) {
              transcriptContainer.dataset.sessionsEnabled = data.sessions_enabled;
            }
            if (data.session_auth_token) {
              transcriptContainer.dataset.sessionAuthToken = data.session_auth_token;
            }
            if (data.podcast_episode_id) {
              transcriptContainer.dataset.podcastEpisodeId = data.podcast_episode_id;
            }

            window.setupTranscript();

            if (typeof window.startPodcastPlaybackSession === 'function') {
              window.startPodcastPlaybackSession();
            }
          } else if (data.transcript_status === 'failed') {
            const podcastAlertEl = document.getElementById('js-podcast-episode-alert');
            const podcastEpisodeGenerateBtnEl = document.getElementById('js-podcast-episode-generate-btn');
            // display error message
            podcastAlertEl.classList.remove('alert-warning');
            podcastAlertEl.classList.add('alert-danger');

            // Built as text nodes, not innerHTML. `data.error` originates in
            // the transcription callback, which is accepted unauthenticated
            // while TRANSCRIPTION_WEBHOOK_ENFORCE is off — so it must never be
            // parsed as markup here. The server also strips and caps it
            // (PodcastEpisode#sanitized_broadcast_error); this is the half that
            // actually closes the sink.
            podcastAlertEl.replaceChildren(
              document.createTextNode(I18n.t('javascript.podcast.transcript_error')),
              document.createElement('br'),
              document.createTextNode(data.error ? `Error: ${data.error}` : '')
            );

            // show and enable generate transcript button
            podcastEpisodeGenerateBtnEl.classList.remove('d-none');
            podcastEpisodeGenerateBtnEl.disabled = false;
          }
        }
      });
    }
  }

  if (podcastEpisodeEl) {
    let podcastEpisodeId = podcastEpisodeEl.dataset.podcastEpisodeId;
    let podcastEpisodeStatus = podcastEpisodeEl.dataset.podcastEpisodeStatus;
    window.subscribePodcastEpisodeChannel(podcastEpisodeId, podcastEpisodeStatus);
  }
})
